<template>
<div class="kt-form__section" :class="_class">
    <slot></slot>
</div>
</template>

<script>
export default {
    props: {
        is_first: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        _class: function() {
            let _class = []

            if(this.is_first === true) {
                _class.push('kt-form__section--first')
            }

            return _class
        }
    }
}
</script>